import angular from "angular";
import TableAudit from "servicestack/table-audit/table-audit";

const dependencies = ['emun.auth', 'webutils', 'webforms', 'webmodals', 'ui.router'];

export default angular.module('table-audit', dependencies)
  .component('tableAudit', TableAudit)
  .name;